export default class Configurator {
  constructor() {
    document.querySelectorAll('[href*="#konfigurator"]').forEach((item) => {
      item.addEventListener('click', () => {
        window.triggerEvent('open_app', true);
      })
    })
    
    if (window.location.href.indexOf("#konfigurator") > -1) {
      window.triggerEvent('open_app', true);
    }
    
    if (this.setVars()) {
      this.setEvents();
    }
  }
  
  setVars() {
    this.settings = {
      main: 'data-open-app'
    };
    
    this.apps = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.apps) return;
    
    return true;
  }
  
  setEvents() {
    this.apps.forEach(app => {
      app.addEventListener('click', () => {
        window.triggerEvent('open_app', true);
      })
    });
  }
  
}
